import {
  Flex,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import React from 'react';
import { AiScoringConstants } from '../aiScoringConstants';
import { HelpCircle } from '@kula-ai/icons-core';

const defaultTriggerElement = (
  <Box cursor="pointer">
    <KText color="primary-600" fontWeight="550">
      See all
    </KText>
  </Box>
);

export const AiSupportAttributes = ({
  triggerElement = defaultTriggerElement,
  popoverContentProps = {},
}: {
  triggerElement?: React.ReactNode;
  popoverContentProps?: any;
}) => {
  const { highlightItems } = AiScoringConstants;

  const totalItems = highlightItems.length;

  return (
    <Popover placement="top">
      {/* @ts-expect-error Chakra PopoverTrigger requires a single child element type it cannot infer */}
      <PopoverTrigger>{triggerElement}</PopoverTrigger>
      <PopoverContent w="481px" mr="120px" top="100px" {...popoverContentProps}>
        <Flex flexDir="column" w="100%">
          <Flex
            justifyContent="space-between"
            w="100%"
            p="12px"
            borderBottom="1px solid"
            borderColor="secondary-100"
          >
            <KText variant="heading_2">Supported attribute types</KText>
            <Flex alignItems="center" gap="6px" cursor="pointer">
              <HelpCircle size={15} className="!text-secondary-700" />
              <KText
                color="primary-600"
                fontWeight="550"
                onClick={() => {
                  window.open('https://support.kula.ai/', '_blank');
                }}
              >
                Help
              </KText>
            </Flex>
          </Flex>
          <Flex
            flexDir="column"
            gap="6px"
            h="100%"
            overflowY="auto"
            maxH="700px"
          >
            {highlightItems.map((item, index) => (
              <Flex
                key={`${item.label}-${index}`}
                flexDir="column"
                gap="6px"
                p="9px 12px"
                borderBottom="1px solid"
                borderColor="secondary-100"
                borderBottomRadius={index === totalItems - 1 ? '6px' : '0px'}
              >
                <KText variant="overhead">{item.label}</KText>
                <KText>{item.description}</KText>
              </Flex>
            ))}
          </Flex>
        </Flex>
      </PopoverContent>
    </Popover>
  );
};
